<p class="fms-notification-title" *ngIf="title">{{ title }}</p>
<img
  *ngIf="imageUrl"
  class="fms-notification-image"
  [class.fms-notification-image--clickable]="isClickable"
  [src]="imageUrl"
  [alt]="alt"
  (click)="open()"
  (keyup.enter)="open()"
  [attr.tabindex]="isClickable ? 0 : null"
  [attr.role]="isClickable ? 'button' : null"
/>
<p class="fms-notification-body" *ngIf="body">{{ body }}</p>
